import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { IconButton, Tooltip } from "@mui/material";
import StreetviewIcon from "@mui/icons-material/Streetview";

import StreetViewDialog from "./streetViewDialog/StreetViewDialog";

function StreetViewAction({ latitude, longitude }) {
  const { t } = useTranslation();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <Tooltip title={t("common.viewStreetView")} arrow>
        <IconButton
          size="small"
          onClick={(event) => {
            event.stopPropagation();
            setIsDialogOpen(true);
          }}
        >
          <StreetviewIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <StreetViewDialog
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        latitude={latitude}
        longitude={longitude}
      />
    </>
  );
}

export default StreetViewAction;
